import React from 'react'

const IconEye = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='18'
      viewBox='0 0 23 18'
      fill='none'
    >
      <path
        d='M22.6441 8.7449C20.8567 4.08104 16.4894 0.937674 11.5363 0.75C6.58334 0.937934 2.21637 4.08125 0.429058 8.7449C0.370002 8.90969 0.370001 9.09013 0.429058 9.25492C2.21617 13.9188 6.58318 17.0624 11.5363 17.2505C16.4894 17.0628 20.8567 13.9195 22.6441 9.25558C22.7032 9.0908 22.7032 8.90969 22.6441 8.7449ZM11.5363 15.7504C7.59617 15.7504 3.43204 12.803 1.92328 9.00024C3.43204 5.19746 7.59551 2.25004 11.5363 2.25004C15.477 2.25004 19.6405 5.19746 21.1493 9.00024C19.6398 12.803 15.477 15.7504 11.5363 15.7504Z'
        className='fill-[#BDD9FD] group-hover:fill-primaryBlue transition-colors duration-200'
      />
      <path
        d='M11.3525 4.55273C8.88478 4.55273 6.88428 6.46503 6.88428 8.82397C6.88428 11.1829 8.88478 13.0952 11.3525 13.0952C13.8203 13.0952 15.8208 11.1829 15.8208 8.82397C15.8208 6.46503 13.8203 4.55273 11.3525 4.55273ZM11.3525 11.6715C9.70736 11.6715 8.37369 10.3966 8.37369 8.82397C8.37369 7.25135 9.70736 5.97648 11.3525 5.97648C12.9977 5.97648 14.3313 7.25135 14.3313 8.82397C14.3313 10.3966 12.9977 11.6715 11.3525 11.6715Z'
        className='fill-[#BDD9FD] group-hover:fill-primaryBlue transition-colors duration-200'
      />
    </svg>
  )
}

export default IconEye
